import React from 'react';
import DialogComponent from '../../../component/dialog/dialog.component';
import i18n from '../../../i18n';
import { Box } from '@mui/material';
import { Dish, Order } from '../../../models';
import './scss/order-detail-dialog.style.scss';
import {
    OrderDetailDishListBlock,
    OrderDetailOrderSummaryBlock,
    OrderDetailPaymentQueueBlock,
} from './order-detail-dialog-blocks';

/** 订单详情弹窗 Props */
type Props = {
    handleClose: () => void;
    open: boolean;
    /** 订单头信息（订单号、桌台、人数等），可为空 */
    order: Order | null;
    /** 订单菜品列表 */
    list: Dish[];
    isTableLoading: boolean;
    /** @deprecated 摘要固定展示总金额/应付/已付，该参数已忽略 */
    hidePaidAmount?: boolean;
    /** @deprecated 摘要固定展示总金额/应付/已付，该参数已忽略 */
    summaryMainAmountKind?: 'payable' | 'actual';
};

/**
 * 订单详情弹窗：按 Figma 设计稿「订单详情弹窗」实现
 * 含订单信息区（白底圆角）+ 菜品区（额外费用表在上、普通菜品表在下；额外费用表无状态列，可纵向滚动）。
 * 摘要区固定展示总金额/应付/已付；已结算（有 `order_end_time`）仅展示已付。
 */
const OrderDetailDialog = ({
    handleClose,
    open,
    order,
    list,
    isTableLoading,
}: Props) => {
    return (
        <DialogComponent
            fullWidth={true}
            heightSize="large"
            defaultHeaderProps={{
                title: i18n.t('immediate_order_details'),
                onClose: handleClose,
                titleAlign: 'center',
            }}
            maxWidth="lg"
            open={open}
            onClose={handleClose}
        >
            <Box
                className="order-detail-dialog-content"
                sx={{
                    px: 2,
                    py: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <OrderDetailOrderSummaryBlock order={order} layout="analysis" />
                <OrderDetailPaymentQueueBlock order={order} />
                <OrderDetailDishListBlock list={list} isTableLoading={isTableLoading} />
            </Box>
        </DialogComponent>
    );
};

export default OrderDetailDialog;
